import instance from "../utils/request.js"
import { getRequest } from "../utils/request.js"

/*获取菜单信息*/
export function GetFunction(data = {}){
return instance.request({
        method: "get",
        url: "lzjaiopsbase/function/",
        params:data
    })
}
/*获取功能编辑信息*/
export function FunctionEditInfo(data = {}){
return instance.request({
        method: "get",
        url: "lzjaiopsbase/functionedit/",
        params:data
    })
}

/*功能编辑*/
export function FunctionEdit(data = {}){
    let params = new URLSearchParams();
    params.append('menufunctionid',data.menufunctionid);
    params.append('functionname',data.functionname);
    params.append('functiondescription',data.functiondescription);
    params.append('menulevel',data.menulevel);
    params.append('accesspath',data.accesspath);
    params.append('iconcls',data.iconcls);
    params.append('parentid',data.parentid);
return instance.request({
        method: "post",
        url: "lzjaiopsbase/functionedit/",
        data:params
    })
}

/*功能新增*/
export function FunctionAdd(data = {}){
    let params = new URLSearchParams();
    params.append('functionname',data.functionname);
    params.append('functiondescription',data.functiondescription);
    params.append('menulevel',data.menulevel);
    params.append('accesspath',data.accesspath);
    params.append('iconcls',data.iconcls);
    params.append('parentid',data.parentid);
return instance.request({
        method: "post",
        url: "lzjaiopsbase/functionadd/",
        data:params
    })
}

/*功能删除*/
export function FunctionDel(data = {}){
    let params = new URLSearchParams();
    params.append('menufunctionid',data.menufunctionid)
return instance.request({
        method: "post",
        url: "lzjaiopsbase/functiondel/",
        data:params
    })
}